export function buildSearchEndpointOverride(searchForm) {
  const form = searchForm && typeof searchForm === 'object' ? searchForm : {}
  const clean = (value) => (value == null ? '' : String(value).trim())
  // loadingAddress/unloadingAddress 为新增任务持久化字段；startAddress/endAddress 为导出等临时覆盖
  const result = {
    startLonlat: clean(form.startLonlat),
    endLonlat: clean(form.endLonlat),
    startAreaCode: clean(form.startAreaCode),
    endAreaCode: clean(form.endAreaCode),
    startAddress: clean(form.startAddress) || clean(form.loadingAddress),
    endAddress: clean(form.endAddress) || clean(form.unloadingAddress)
  }
  for (const key of ['loadLonlat', 'loadAddress', 'unloadLonlat', 'unloadAddress']) {
    if (clean(form[key])) result[key] = clean(form[key])
  }
  return Object.values(result).some(Boolean) ? result : null
}

export function getSearchEndpointPairError(endpoint) {
  const value = endpoint && typeof endpoint === 'object' ? endpoint : {}
  const has = (field) => value[field] != null && String(value[field]).trim() !== ''

  if (has('startAreaCode') && !has('endAreaCode')) return '请输入目的地'
  if (!has('startAreaCode') && has('endAreaCode')) return '请输入始发地'
  if (has('startLonlat') && !has('endLonlat')) return '请输入目的地坐标'
  if (!has('startLonlat') && has('endLonlat')) return '请输入始发地坐标'
  return ''
}
